window.updateCartCount = async function() {
  try {
    // Fetch the current cart
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to fetch cart');

    const cart = await response.json();
    const itemCount = cart.item_count || 0;

    // Find the cart count element on the page
    const cartBubble = document.querySelector('.cart-count-bubble');
    if (cartBubble) {
      cartBubble.textContent = itemCount;
    } else {
      console.warn('Cart count element not found');
    }

  } catch (error) {
    console.error('Error updating cart count:', error);
  }
};
function getField(name){
    return document.querySelector(`input[name="${name}"], select[name="${name}"], textarea[name="${name}"]`);
}

function copyBillingToShipping(checkboxName, fieldMap){

    const checkbox = document.querySelector(`input[name="${checkboxName}"]`);

    if(!checkbox){
        //console.warn(`Checkbox "${checkboxName}" not found. Retrying...`);
        return setTimeout(() => copyBillingToShipping(checkboxName, fieldMap), 400);
    }

    //console.log("✔ Checkbox ready");

    checkbox.addEventListener("change", function(){

        const isChecked = this.checked;

        Object.keys(fieldMap).forEach(bill => {
            const billing  = getField(bill);
            const shipping = getField(fieldMap[bill]);

            if(!billing || !shipping) return;

            if(isChecked){

                // initial copy on check
                shipping.value = billing.value;
                shipping.dispatchEvent(new Event("change", {bubbles:true}));

                // live update on billing change
                billing.addEventListener("input",  ()=>{ if(isChecked) {shipping.value = billing.value; shipping.dispatchEvent(new Event("change",{bubbles:true}));}});
                billing.addEventListener("change", ()=>{ if(isChecked) {shipping.value = billing.value; shipping.dispatchEvent(new Event("change",{bubbles:true}));}});

            } else {
                // restore clearance when unchecked
                shipping.value = "";
                shipping.dispatchEvent(new Event("change", {bubbles:true}));
            }
        });

    });
}


document.addEventListener("DOMContentLoaded", function(){

    
    copyBillingToShipping("copy_billing_to_shipping", {
        billing_organization_name: "shipping_org_name",
        billing_attention: "shipping_info_attention",
        billing_address1: "shipping_info_address1",
        billing_address2: "shipping_info_address2",
        billing_city: "shipping_info_city",
        billing_state: "shipping_info_state",
        billing_postal_code: "shipping_info_zipcode",
        billing_phone_number: "shipping_info_phone_number",
        billing_email_address: "shipping_info_email",
        billing_county: "shipping_info_county"
    });
    setTimeout(function(){
          const countiesJsonUrl = 'https://naloxzone.com/cdn/shop/t/1/assets/us-counties.json';

          let countiesByState = {};

          // Load counties JSON once
          fetch(countiesJsonUrl)
            .then(function (response) {
              if (!response.ok) {
                throw new Error('HTTP ' + response.status);
              }
              return response.json();
            })
            .then(function (data) {
              countiesByState = data;

              // Init both billing + shipping
              initDropdown('billing_state_1', 'billing_county');
              initDropdown('shipping_info_state', 'shipping_info_county_1');
            })
            .catch(function (error) {
              console.error('Failed to load counties JSON', error);
            });

          /**
           * State → County dropdown logic
           */
          function initDropdown(stateFieldName, countyFieldName) {
            const stateField = document.querySelector(`[name="${stateFieldName}"]`);
            const countyField = document.querySelector(`[name="${countyFieldName}"]`);

            if (!stateField || !countyField) {
              console.warn(`Fields not found: ${stateFieldName}, ${countyFieldName}`);
              return;
            }

            // Reset county dropdown
            countyField.innerHTML = '<option value="">Select County</option>';

            // Populate on state change
            stateField.addEventListener('change', function () {
              const state = this.value;

              countyField.innerHTML = '<option value="">Select County</option>';

              if (!state || !countiesByState[state]) return;

              countiesByState[state].forEach(function (county) {
                const option = document.createElement('option');
                option.value = county;
                option.textContent = county;
                countyField.appendChild(option);
              });
            });
          }
    },2000)
    
});

window.refreshCartIconBubble = async function () {
  try {
    const res = await fetch(window.location.href, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch page HTML: ${res.status}`);
    }

    const htmlText = await res.text();

    // Parse fetched HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');

    const newBubble = doc.querySelector('#cart-icon-bubble');
    const currentBubble = document.querySelector('#cart-icon-bubble');

    if (!newBubble || !currentBubble) {
      console.warn('cart-icon-bubble not found in fetched or current DOM');
      return;
    }

    // Replace innerHTML only (safe, avoids reloading listeners on parent)
    currentBubble.innerHTML = newBubble.innerHTML;

    console.log('Cart icon bubble refreshed');

  } catch (err) {
    console.error('Error refreshing cart icon bubble:', err);
  }
};
